import { Badge, BadgeProps, makeStyles } from '@fluentui/react-components';

import { TTrainingStatus } from '../types';

// Status badge for a training item, mirroring the item StatusBadge/RoleBadge
// convention (tinted badge, normal font weight). "Completed" reuses the app's
// green brand colour used for approved items.
const STATUS_CONFIG: Record<TTrainingStatus, { color: BadgeProps['color']; label: string }> = {
  open: { color: 'warning', label: 'Open' },
  completed: { color: 'brand', label: 'Completed' },
  overdue: { color: 'danger', label: 'Overdue' },
  outdated: { color: 'severe', label: 'Outdated revision' },
  'not-trained': { color: 'subtle', label: 'Not trained' },
};

const useStyles = makeStyles({
  root: {
    fontWeight: 'normal',
  },
});

type TProps = {
  status: TTrainingStatus;
};

const TrainingStatusBadge = ({ status }: TProps) => {
  const classes = useStyles();
  const { color, label } = STATUS_CONFIG[status];

  return (
    <Badge color={color} appearance="tint" className={classes.root}>
      {label}
    </Badge>
  );
};

export default TrainingStatusBadge;
